import { config } from 'config';

import { API_VERSIONS } from '../constants';
import { getClient } from '../utils/httpClient/httpClient.config';

/**
 Returns Redux action with input value as type and payload if input is a string,
 calls action creator with payload if it's a function.
*/
const typeOrFunctionAction = (input, payload) => {
  if (typeof input === 'string') {
    if (payload === undefined) {
      return { type: input };
    }
    return { type: input, payload };
  }
  if (typeof input === 'function') {
    return input(payload);
  }
  return input;
};

const createFetchActionCreator =
  (method) =>
  (
    endpoint,
    { request, success, failure, params, data, version = API_VERSIONS.v2 },
  ) =>
  (dispatch) => {
    // check if provided `version` is valid and if not, take `v2` as default
    const apiVersion = Object.values(API_VERSIONS).includes(version)
      ? version
      : API_VERSIONS.v2;
    const apiUrl = config[apiVersion];

    dispatch(typeOrFunctionAction(request));
    return getClient()
      .request({
        params,
        data,
        method,
        baseURL: apiUrl,
        url: endpoint,
      })
      .then((response) => {
        dispatch(
          typeOrFunctionAction(success, response.data.data || response.data),
        );
        return true;
      })
      .catch((error) => {
        dispatch(
          typeOrFunctionAction(
            failure,
            error.response && error.response.data
              ? { ...error.response.data, status: error.response.status }
              : error.message,
          ),
        );
        return false;
      });
  };

const methods = {
  get: createFetchActionCreator('GET'),
  post: createFetchActionCreator('POST'),
  put: createFetchActionCreator('PUT'),
  patch: createFetchActionCreator('PATCH'),
  delete: createFetchActionCreator('DELETE'),
};

export default methods;
